//inject app sagas
import uploadDocumentSaga from 'containers/UploadDocuments/sagas';
import appContainerSagas from 'containers/AppContainer/sagas';
import requestSearchClaimsSagas from 'containers/IdentificationPage/sagas';
import requestStatsClaimsSagas from 'containers/HomePage/sagas';
import { loginSaga, logOutSaga } from 'containers/LoginPage/sagas';
import recapPageSagas from 'containers/RecapPage/sagas';
import requestPendingClaimsSaga from 'containers/PendingClaimsPage/sagas';
import requestRejectedClaimsSaga from 'containers/ManagerRejectedClaimsPage/sagas';
import requestValidatedClaimsSaga from 'containers/ValidatedClaimsPage/sagas';
import requestManagerPendingClaimsSaga from 'containers/ManagerPendingClaims/sagas';
import recapManagerPage from 'containers/RecapManagerPage/sagas';
import requestManagerOpenedClaimsSaga from 'containers/ManagerOpenedClaimsPage/sagas';
import requestLawyerRejectedClaimsSaga from 'containers/RejectedClaimsPage/sagas';
import requestExistantClaimsSagas from 'containers/ManagerDocumentsPage/sagas';
import requestExistantClaimsForLawyerSagas from 'containers/LawyerDocumentsPage/sagas';
import courtManagerSagas from 'containers/CourtManagerAssignedClaims/sagas';
import requestManagerHomePageSaga from 'containers/ManagerHomePage/sagas';
import requestLawyerAssignedClaimsSaga from 'containers/LawyerAssignmentsPage/sagas';
import LawyerLegalProceedingsSaga from 'containers/LawyerLegalProceedingsPage/sagas';
import CourtManagerLegalProceedingsSaga from 'containers/CourtManagerLegalProceedings/sagas';
import LawyerFeeNoteSaga from 'containers/LawyerFeeNote/sagas';
import ManagerFeeNoteSaga from 'containers/ManagerFeeNote/sagas';
import CourtManagerAssignedExpertise from 'containers/CourtManagerAssignedExpertise/sagas';
import sagisClaimSagas from 'containers/CourtManagerLegalProceedings/Provision/redux/sagas';
import expertAssignedMissionShowSagas from 'containers/ExpertAssignedMissionShow/sagas';
import expertExpertiseSagas from 'containers/ExpertExpertise/sagas';
import expertExpertiseMissionsSagas from 'containers/ExpertAssignedMissions/sagas';
import searchMissionsSagas from 'containers/ExpertHomePage/sagas';
import preOpenClaimSagas from 'containers/PreOpeningPage/sagas';
import openClaimSaga from 'containers/OpeningClaimPageManager/saga';
import AttributionManagerSaga from 'containers/AttributionManager/saga';
import UploadDocumentsManagerSaga from 'containers/UploadDocumentsManager/sagas';
import PreOpenManagerValidatedClaimsSaga from 'containers/PreOpenManagerValidatedClaims/sagas';
import PreOpenManagerRejectedClaimsSaga from 'containers/PreOpenManagerRejectedClaims/sagas';
import PreOpenManagerPendingClaimsSaga from 'containers/PreOpenManagerPendingClaims/sagas';
import ManagerPendingTreatementClaimsSaga from 'containers/ManagerPendingTreatementClaims/sagas';
import PreOpenManagerFeeNoteSaga from 'containers/PreOpenManagerFeeNote/saga';
import TransactionManagerTimeLineSaga from 'containers/TransactionManagerTimeLine/sagas';
import preOpenBasicClaimSagas from 'containers/BasicManagement/redux/sagas';
import ManagerManagementSaga from 'containers/ManagerManagement/saga';
import IntervenantManagementSaga from 'containers/IntervenantManagement/saga';
import UploadDocumentV2Saga from 'containers/common/UploadDocument/saga';
import CommonLegalProceeding from 'containers/common/LegalProceedings/saga';
import ProvisionalClaimSagas from 'containers/ProvisionalClaimsPage/sagas';
import ProvisionalClaimDetailsSagas from 'containers/ProvisionalClaimRecap/sagas';
import UsageClaimsSaga from 'containers/UsageClaimsPage/sagas';

export default [
  loginSaga,
  logOutSaga,
  ...appContainerSagas,
  ...uploadDocumentSaga,
  ...requestSearchClaimsSagas,
  ...requestStatsClaimsSagas,
  ...recapPageSagas,
  ...recapManagerPage,
  ...requestPendingClaimsSaga,
  ...requestRejectedClaimsSaga,
  ...requestValidatedClaimsSaga,
  ...requestManagerPendingClaimsSaga,
  ...requestManagerOpenedClaimsSaga,
  ...requestLawyerRejectedClaimsSaga,
  ...requestExistantClaimsSagas,
  ...requestExistantClaimsForLawyerSagas,
  ...courtManagerSagas,
  ...requestManagerHomePageSaga,
  ...requestLawyerAssignedClaimsSaga,
  ...LawyerLegalProceedingsSaga,
  ...CourtManagerLegalProceedingsSaga,
  ...LawyerFeeNoteSaga,
  ...ManagerFeeNoteSaga,
  ...CourtManagerAssignedExpertise,
  ...sagisClaimSagas,
  ...expertAssignedMissionShowSagas,
  ...expertExpertiseSagas,
  ...expertExpertiseMissionsSagas,
  ...searchMissionsSagas,
  ...preOpenClaimSagas,
  ...openClaimSaga,
  ...AttributionManagerSaga,
  ...UploadDocumentsManagerSaga,
  ...PreOpenManagerValidatedClaimsSaga,
  ...PreOpenManagerRejectedClaimsSaga,
  ...PreOpenManagerPendingClaimsSaga,
  ...ManagerPendingTreatementClaimsSaga,
  ...PreOpenManagerFeeNoteSaga,
  ...TransactionManagerTimeLineSaga,
  ...preOpenBasicClaimSagas,
  ...ManagerManagementSaga,
  ...IntervenantManagementSaga,
  ...UploadDocumentV2Saga,
  ...CommonLegalProceeding,
  ...ProvisionalClaimSagas,
  ...ProvisionalClaimDetailsSagas,
  ...UsageClaimsSaga,
];
